const activeClass = 'is-active'
const body = document.querySelector('body')
const header = document.querySelector('.header')
const navTrigger = document.querySelector('.js-nav-trigger')
const navClose = document.querySelector('.js-nav-close')
const navDropdowns = document.querySelectorAll('.nav .nav__dropdown')
const navSubDropdowns = document.querySelectorAll('.nav .nav__dropdown-item')

function hideDropdown(dropdownElement) {
  dropdownElement.forEach(function (el, index) {
    if (window.innerWidth < 960) {
      el.classList.remove(activeClass)
    }
  })
}

header
  .querySelector('.header__screen')
  .addEventListener('click', function (evt) {
    evt.preventDefault()

    header.classList.remove(activeClass)
    navTrigger.classList.remove(activeClass)
    let activeItems = header.querySelectorAll(`li.${activeClass}`);
    [...activeItems].forEach((element) => {
      element.classList.remove(activeClass)
    })
    body.classList.remove('menu-opened')

    hideDropdown(navDropdowns)
    hideDropdown(navSubDropdowns)
  })

navTrigger.addEventListener('click', function (evt) {
  evt.preventDefault()
  this.classList.toggle(activeClass)
  header.classList.toggle(activeClass)
  body.classList.toggle('menu-opened')

  hideDropdown(navDropdowns)
  hideDropdown(navSubDropdowns)
})

navClose.addEventListener('click', function (evt) {
  evt.preventDefault()
  this.classList.remove(activeClass)
  header.classList.remove(activeClass)
  navTrigger.classList.remove(activeClass)
  body.classList.remove('menu-opened')

  hideDropdown(navDropdowns)
  hideDropdown(navSubDropdowns)
})
